import * as Types from '../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EpocusProgramQaWorkloadQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
}>;


export type EpocusProgramQaWorkloadQuery = { readonly __typename?: 'Query', readonly epocusProgramQaWorkload: { readonly __typename?: 'EpocusProgramQaWorkload', readonly programId: string, readonly turnaroundTargetMinutes?: number | null, readonly turnaroundWindowDays: number, readonly activeReviewerWindowDays: number, readonly pending: number, readonly overdue: number, readonly activeReviewers: number, readonly unassignedInPool: number, readonly byReviewer: ReadonlyArray<{ readonly __typename?: 'EpocusQaWorkloadReviewer', readonly reviewerId: string, readonly name?: string | null, readonly open: number, readonly overdue: number, readonly medianTurnaroundMinutes?: number | null, readonly withinTargetPct?: number | null }> } };


export const EpocusProgramQaWorkloadDocument = gql`
    query EpocusProgramQaWorkload($programId: ID!) {
  epocusProgramQaWorkload(programId: $programId) {
    programId
    turnaroundTargetMinutes
    turnaroundWindowDays
    activeReviewerWindowDays
    pending
    overdue
    activeReviewers
    unassignedInPool
    byReviewer {
      reviewerId
      name
      open
      overdue
      medianTurnaroundMinutes
      withinTargetPct
    }
  }
}
    `;

/**
 * __useEpocusProgramQaWorkloadQuery__
 *
 * To run a query within a React component, call `useEpocusProgramQaWorkloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusProgramQaWorkloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusProgramQaWorkloadQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useEpocusProgramQaWorkloadQuery(baseOptions: Apollo.QueryHookOptions<EpocusProgramQaWorkloadQuery, EpocusProgramQaWorkloadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusProgramQaWorkloadQuery, EpocusProgramQaWorkloadQueryVariables>(EpocusProgramQaWorkloadDocument, options);
      }
export function useEpocusProgramQaWorkloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusProgramQaWorkloadQuery, EpocusProgramQaWorkloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusProgramQaWorkloadQuery, EpocusProgramQaWorkloadQueryVariables>(EpocusProgramQaWorkloadDocument, options);
        }
export type EpocusProgramQaWorkloadQueryHookResult = ReturnType<typeof useEpocusProgramQaWorkloadQuery>;
export type EpocusProgramQaWorkloadLazyQueryHookResult = ReturnType<typeof useEpocusProgramQaWorkloadLazyQuery>;
export type EpocusProgramQaWorkloadQueryResult = Apollo.QueryResult<EpocusProgramQaWorkloadQuery, EpocusProgramQaWorkloadQueryVariables>;